import * as z from "zod/v4";

export const MAX_PERMIT_CAPACITY = 50_000;

export const DEFAULT_PLATE_LIMIT = 4;

const PERMIT_STATUS_TYPES = ["ACTIVE", "VOID", "UPCOMING", "EXPIRED"] as const;
const permitStatusSchema = z.enum(PERMIT_STATUS_TYPES);
export type PermitStatus = z.infer<typeof permitStatusSchema>;

export const PermitStatus = permitStatusSchema.enum;

export type PermitStatusInterval = {
	startDateTime: Date;
	endDateTime: Date | null;
};

export const resolvePermitStatus = ({
	isDeleted,
	intervals,
	now,
}: {
	isDeleted: boolean;
	intervals: readonly PermitStatusInterval[];
	now: Date;
}): PermitStatus => {
	if (isDeleted) {
		return PermitStatus.VOID;
	}

	const anyIntervalActive = intervals.some(
		(interval) => interval.startDateTime <= now && (interval.endDateTime === null || now < interval.endDateTime),
	);
	if (anyIntervalActive) {
		return PermitStatus.ACTIVE;
	}

	return intervals.some((interval) => now < interval.startDateTime) ? PermitStatus.UPCOMING : PermitStatus.EXPIRED;
};
